import React, { useEffect } from 'react';
import {
  Grid,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  TableContainer,
  Box,
  Select,
  MenuItem,
  InputLabel,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import { useStyles } from './Style';
import { useBusiness , useCurrencyUnit} from 'hooks';
import { SimpleDialog, InputV2, DealingList, ComparativeAccount , Icons , InputCurrency} from 'components';
import comparativeAccountServices from 'components/ComparativeAccount/services/ComparativeAccountServices';
import { useFieldArray, useForm, useFormContext } from 'react-hook-form';
import { LabelLine } from 'components/InputV2/components';
import createToast from 'components/Toast/Toast';
import ForeachLodash from 'lodash/forEach';
import useCustomHook from '../../../../hooks';

const Beneficiary = ({ setBeneficiary, stakeholderList, beneficiary }) => {
  const classes = useStyles();
  const params = useParams();
  const methods = useFormContext();
  const businessInfo = useBusiness();
  const {
    openDialog,
    setOpenDialog,
    indexSelected,
    setIndexSelected,
    mySharePercent,
    setMySharePercent,
    enterPercent,
    setEnterPercent,
    useOfpercentage,
    setUseOfpercentage,
    comparativeAccountList,
    setComparativeAccountList,
  } = useCustomHook();
  const currencyText = useCurrencyUnit(false);

  const { register, formState: { errors }, trigger, control, getValues, reset } = useForm({
    mode: 'onChange',
  });

  const { fields, append, remove } = useFieldArray({
    control: methods.control,
    name: 'scStakeholderList',
  });

  useEffect(() => {
    const businessIds = [];
    const guildCodes = [];
    const percentages = [];
    const amounts = [];
    ForeachLodash(fields, (item) => {
      businessIds.push(item.businessName.id);
      guildCodes.push(item.guildCodes.code);

      if (useOfpercentage) {
        percentages.push(item.percentage);
      } else {
        amounts.push(item.fixedShareAmount);
      }
    });
    const d = { businessIds, guildCodes, percentages, amounts };
    if (JSON.stringify(beneficiary) != JSON.stringify(d)) {
      setBeneficiary(d);
    }
  }, [fields, useOfpercentage]);

  useEffect(() => {
    (async () => {
      try {
        const result = await comparativeAccountServices.getList();
        const { data } = result;
        setComparativeAccountList({
          list: data.result.guilds,
        });
      } catch (error) { }
    })();

    //
  }, []);

  const removeRow = (index) => {
    setIndexSelected(index);
    setOpenDialog(true);
  };

  const confirmRemove = () => {
    const rowValues = fields[indexSelected];

    if (rowValues.percentage) {
      setMySharePercent((val) => val - rowValues.percentage);
    }

    setOpenDialog(false);
    remove(indexSelected);
    setIndexSelected(-1);
  };

  const closeDialog = () => {
    setOpenDialog(false);
  };

  const addRow = async () => {
    try {
      let checkValidation = [];

      if (useOfpercentage) {
        checkValidation.push('rowPercentage');
      } else if (!useOfpercentage) {
        checkValidation.push('rowFixedShareAmount');
      }

      const valid = await trigger(['rowGuildId', 'rowComparativeAccount', ...checkValidation]);

      const ownerShare = {
        percentShare: 100,
        discountSharePercent: 100,
      };

      const rowPercentage = parseFloat(getValues('rowPercentage'));

      if (rowPercentage) {
        if (mySharePercent + rowPercentage > 100) {
          createToast('خطا', 'جمع درصدهای تسهیم بیشتر از 100 درصد است');
          return;
        }
        setEnterPercent(true);
        ownerShare.percentShare -= mySharePercent + rowPercentage;
        setMySharePercent((val) => val + rowPercentage);
      }

      if (valid) {
        const rowValues = {
          guildId: getValues('rowGuildId'),
          businessName: getValues('rowGuildId'),
          fixedShareAmount: getValues('rowFixedShareAmount'),
          percentage: getValues('rowPercentage'),
          guildCodes: getValues('rowComparativeAccount'),
        };

        append(rowValues);
        reset({
          rowGuildId: '',
          rowFixedShareAmount: '',
          rowPercentage: '',
          rowComparativeAccount: '',
        });
      }
    } catch (e) { }
  };

  const ActionsBtn = () => {
    return (
      <>
        <Button onClick={confirmRemove} variant="contained" color="primary">
          تایید
        </Button>
        <Button onClick={closeDialog} variant="contained">
          انصراف
        </Button>
      </>
    );
  };

  return (
    <>
      <SimpleDialog
        title="حذف ذینفع"
        content="آیا از حذف اطمینان دارید؟"
        open={openDialog}
        actions={<ActionsBtn />}
      />
      <Grid container direction="row" alignItems="center">
        {/* This block will be ignored when submitting the form. */}
        {!params?.id && (
          <>
            <Grid container item xs={12} spacing={3} alignItems="center">
              <Grid item xs={12} sm={3}>
                <DealingList
                  name="rowGuildId"
                  errors={errors}
                  control={control}
                  tooltip="اگر کارگزار موردنظر پیدا نشد باید مجوز کارگزاری از آن کسب و کار دریافت نمایید."
                  required
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <ComparativeAccount
                  errors={errors}
                  control={control}
                  name="rowComparativeAccount"
                  register={register}
                  list={comparativeAccountList.list}
                  variant="filled"
                />
              </Grid>
              {fields.length === 0 && (
                <Grid item xs={12} sm={2}>
                  <InputLabel shrink className={classes.label}>
                    <LabelLine label="نوع تسهیم" />
                  </InputLabel>
                  <Select
                    fullWidth
                    value={useOfpercentage ? 'percent' : 'amount'}
                    onChange={(e) => {
                      setUseOfpercentage(e.target.value === 'percent');
                    }}
                    variant="outlined"
                    style={{ height: 38 }}
                    className="pureSelect"
                  >
                    <MenuItem value="amount">مبلغ</MenuItem>
                    <MenuItem value="percent">درصد</MenuItem>
                  </Select>
                </Grid>
              )}
              <Grid item xs={12} sm={fields.length === 0 ? 3 : 5}>
                {useOfpercentage && (
                  <InputV2
                    label="درصدتسهیم"
                    errors={errors}
                    name="rowPercentage"
                    register={register}
                    // rules={['isNumeric']}
                    fullWidth
                    control={control}
                    currency
                    hasMargin={false}
                    currencyText="%"
                  // tooltip="در صورت ورود مبلغ تسهیم،  درصد تسهیم در نظر گرفته نخواهد شد. جهت ورود درصد تسهیم، مبلغ تسهیم را خالی بگذارید"
                  />
                )}

                {!useOfpercentage && (
                  <InputCurrency
                    label="مبلغ تسهیم"
                    errors={errors}
                    name="rowFixedShareAmount"
                    register={register}
                    rules={['required', 'isNumeric']}
                    fullWidth
                    control={control}
                    hasMargin={false}
                    defaultValue=""
                  // tooltip="جهت ورود درصد تسهیم، مبلغ تسهیم را خالی بگذارید"
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={1}>
                <Button
                  color="primary"
                  variant="outlined"
                  onClick={addRow}
                  style={{ marginTop: 15 }}
                >
                  افزودن
                </Button>
              </Grid>
            </Grid>

            {fields.length > 0 && (
              <Grid item xs={12}>
                <Box mt={3}>
                  <TableContainer component={Paper} className={classes.table}>
                    <Table>
                      <TableHead style={{ backgroundColor: '#eef1f5' }}>
                        <TableRow>
                          <TableCell align="center">شناسه کسب‌وکار</TableCell>
                          <TableCell align="center">نام ذینفع</TableCell>
                          <TableCell align="center">حساب تفصیلی كسب‌و‌كار</TableCell>
                          {!useOfpercentage && (
                            <TableCell align="center">
                              مبلغ تسهیم <small>({currencyText})</small>
                            </TableCell>
                          )}
                          {useOfpercentage && <TableCell align="center">درصد تسهیم</TableCell>}
                          <TableCell align="center">عملیات</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {enterPercent && (
                          <TableRow className={classes.exceptionRow}>
                            <TableCell align="center">{businessInfo.id}</TableCell>
                            <TableCell align="center">{businessInfo.name}</TableCell>
                            <TableCell align="center">-</TableCell>
                            {!useOfpercentage && <TableCell align="center">-</TableCell>}
                            {useOfpercentage && (
                              <TableCell align="center">{100 - mySharePercent} %</TableCell>
                            )}
                            <TableCell align="center" />
                          </TableRow>
                        )}

                        {fields.map((row, index) => (
                          <TableRow key={row.id}>
                            <TableCell align="center">{row.businessName.id}</TableCell>
                            <TableCell align="center" style={{ width: 280 }}>
                              {row?.businessName?.name}
                            </TableCell>
                            <TableCell align="center" style={{ width: 280 }}>
                              {row?.guildCodes?.name}
                            </TableCell>
                            {!useOfpercentage && (
                              <TableCell align="center">{row.fixedShareAmount}</TableCell>
                            )}
                            {useOfpercentage && (
                              <TableCell align="center">{`${row.percentage} %`}</TableCell>
                            )}
                            <TableCell align="center">
                              <IconButton
                                variant="contained"
                                color="primary"
                                aria-label="delete"
                                onClick={() => removeRow(index)}
                              >
                                <Icons icon='Trash' color='#2B3990' size='20' />

                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Grid>
            )}
          </>
        )}

        {params?.id && stakeholderList.length > 0 ? (
          <Grid item xs={12}>
            <Box mt={3}>
              <TableContainer component={Paper} className={classes.table}>
                <Table>
                  <TableHead style={{ backgroundColor: '#eef1f5' }}>
                    <TableRow>
                      <TableCell align="center">شناسه کسب‌وکار</TableCell>
                      <TableCell align="center">نام ذینفع</TableCell>
                      <TableCell align="center">حساب تفصیلی كسب‌و‌كار</TableCell>
                      {stakeholderList[0].amount && (
                        <TableCell align="center">
                          مبلغ تسهیم <small>({currencyText})</small>
                        </TableCell>
                      )}
                      {stakeholderList[0].percentage && (
                        <TableCell align="center">درصد تسهیم</TableCell>
                      )}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {enterPercent && (
                      <TableRow className={classes.exceptionRow}>
                        <TableCell align="center">{businessInfo.id}</TableCell>
                        <TableCell align="center">{businessInfo.name}</TableCell>
                        <TableCell align="center">-</TableCell>
                        {stakeholderList[0].amount && <TableCell align="center">-</TableCell>}
                        {stakeholderList[0].percentage && (
                          <TableCell align="center">
                            {100 -
                              stakeholderList
                                .map((item) => item.percentage * 100)
                                .reduce((prev, current) => {
                                  return prev + current;
                                })}{' '}
                            %
                          </TableCell>
                        )}
                      </TableRow>
                    )}

                    {stakeholderList.map((row, index) => (
                      <TableRow key={`${index}-${row.business.id}`}>
                        <TableCell align="center">{row.business.id}</TableCell>
                        <TableCell align="center" style={{ width: 280 }}>
                          {row.business.name}
                        </TableCell>
                        <TableCell align="center" style={{ width: 280 }}>
                          {row.guild.name}
                        </TableCell>
                        {row.amount && <TableCell align="center">{row.amount}</TableCell>}
                        {row.percentage && (
                          <TableCell align="center">{`${row.percentage * 100} %`}</TableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        ) : params?.id ? (
          <Grid item xs={12}>
            ذینفعی ثبت نشده است
          </Grid>
        ) : null}
      </Grid>
    </>
  );
};

export default React.memo(Beneficiary);
